<template>
  <b-card>
    <certificado-list
      id="certificadoList"
      ref="certificadoList"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :filtros="filtrosPrincipais"
      :info="info"
      :mostrar-remover-lote="false"
    >
      <template slot="botoes-adicionais">
        <b-button
          variant="success btn-sm"
          style="margin-right: 5px;"
          @click="exportarRelatorio"
        >
          Exportar
        </b-button>

        <filtro-adicional-base
          :target="'filtroAdicionalBase'"
          @limpar="LimpaFiltros"
          @aplicar-busca="pesquisarFiltroCertificado"
        >
          <template #conteudo-filtro-adicional>
            <b-row class="search-group mb-1">
              <b-col cols="12">
                <b-form-group
                  label="Data de vencimento"
                >
                  <de-para
                    ref="dataDeVencimento"
                    v-model="dataVencimento"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="search-group mb-1">
              <b-col cols="12">
                <b-form-group
                  label="Tipo de certificado">
                  <b-select
                    v-model="filtros.modeloCertificado"
                    class="search-items"
                    :placeholder="'Tipo de certificado'"
                  >
                    <option
                      v-for="(cert, index) in modeloCertificado"
                      :key="index"
                      :value="cert.value"
                    >{{ cert.text }}</option>
                  </b-select>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </filtro-adicional-base>
      </template>
      <template
        slot="botao-adicional"
        slot-scope="{props}"
      >
        <b-btn
          v-if="userData != null && userData.observacaoCertificado && !permissaoUpdate "
          v-b-tooltip.hover
          title="Editar observação certificado"
          variant="none"
          class=" btn-none rounded-pill icone-acao btn-acoes-historico"
          style="margin-right:0.3rem"
          @click="editarObservacao(props.row)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-btn>
        <b-btn
          v-b-tooltip.hover
          title="Baixar certificado"
          variant="none"
          class=" btn-none rounded-pill icone-acao"
          :class="props.row.tipo == 'A3' ? 'btn-acoes-download-disabled' : 'btn-acoes-download'"
          style="margin-right:0.3rem"
          :disabled="props.row.tipo == 'A3'"
          @click="baixarCertificado(props.row.id)"
        >
          <font-awesome-icon :icon="faDownload" />
        </b-btn>

        <b-btn
          v-b-tooltip.hover
          title="Histórico de baixa do certificado"
          variant="none"
          class=" btn-none rounded-pill icone-acao"
          :class="props.row.tipo == 'A3' ? 'btn-acoes-download-disabled' : 'btn-acoes-historico'"
          style="margin-right:0.3rem"
          :disabled="props.row.tipo == 'A3'"
          @click="showHistoricos(props.row.id)"
        >
          <font-awesome-icon :icon="faHistory" />
        </b-btn>
      </template>
      <template slot="botao-filtro-certificado">
        <div class="col-6 search-group">
          <label
            name="filtroLabelCertificado"
            for="filterCertificado"
            style="left: 1.5rem !important;top: calc( 50% - 0.8rem ) !important;"
            class="fas fa-filter icon"
          />
          <a
            id="downloadRelatorio"
            download
            href=""
            hidden
          />
          <b-select
            v-model="filtros.tipoFiltroCertificado"
            name="filterCertificado"
            class="search-items"
            :placeholder="'Filtro por certificado'"
            @change="pesquisarFiltroCertificado"
          >
            <option
              v-for="(cert, index) in filtroCertificado"
              :key="index"
              :value="cert.value"
            >{{ cert.text }}</option>
          </b-select>
        </div>
      </template>
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.field === 'dataDeVencimento' && validaVencido(props.row.dataDeVencimento)">
          <span style="color: #ea5455;">{{ props.row.dataDeVencimento }}</span>
        </span>
        <span v-else-if="props.column.field === 'dataDeVencimento'">
          {{ props.row.dataDeVencimento }}
        </span>
        <span
          v-else-if="props.column.field === 'empresaSocio'"
          :class=" permissaoUpdate && props.column.editable ? 'editable-column' : ''"
          @click="editar(props.row)"
        >
          {{ props.row.empresaSocio }}
          <span
            :class="['ativo-badge', {'badge badge-success':props.row.statusCertificado === 'Ativo',
                                     'badge badge-danger': props.row.statusCertificado === 'Inativo',
                                     'badge badge-vencido': props.row.statusCertificado === 'Vencido',
                                     'badge badge-em-processo': props.row.statusCertificado === 'Em processo' }]"
          >
            {{ props.row.statusCertificado === 'Ativo' ? 'Ativo' : props.row.statusCertificado === 'Inativo' ? 'Inativo' : props.row.statusCertificado === 'Em processo' ? 'Em processo' : 'Vencido' }}
          </span>
        </span>
        <span
          v-else-if="props.column.field === 'observacao'"
          v-b-tooltip.hover
          :title="props.row.observacao"
        >
          <p
            style="overflow: hidden; width:25ch; text-overflow: ellipsis; white-space:nowrap;"
          >
            {{ props.row.observacao }}
          </p>
        </span>
      </template>
    </certificado-list>
    <historico-certificado
      ref="historicoCertificado"
      :certificado-id="1"
    />
  </b-card>
</template>

<style lang="scss">
#certificadoList .editable-column {
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
}

.linha-vertical {
  height: 30px;/*Altura da linha*/
  border-right: 1px solid rgb(163 164 166 / 88%);/* Adiciona borda direita na div como ser fosse uma linha.*/
}

.badge-dados-empresa {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.badge-dados-controle {
  height: 1.3rem;
  font-size: 10px;
  font-weight: 750;
  border-radius: 2px;
  margin-left: 0.5rem;
  padding: 4px;
}

.badge-parcial {
  background-color: #ff8d00;
}

.badge-controle {
  border-width: 1px;
  border-style: solid;
}

.badge-vencido {
  color: #ea5455;
  border: 1px solid #ea5455;
  background-color: transparent;
}

.badge-em-processo {
  color: #fff;
  border: 1px solid #c1af1d;
  background-color: #c1af1d;
}

.btn-acoes-download {
  border: 1px solid #1d9553 !important;
  background-color: transparent;
  color: #1d9553 !important;

  :hover {
    color: #1d9553 !important;
  }
}

.btn-acoes-historico {
  border: 1px solid #c1af1d !important;
  background-color: transparent;
  color: #c1af1d !important;

  :hover {
    color: #c1af1d !important;
  }
}

.btn-acoes-download-disabled {
  border: 1px solid #82868b !important;
  background-color: transparent;
  color: #82868b !important;

  :hover {
    color: #82868b !important;
  }
}

</style>

<script>
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faDownload, faHistory } from '@fortawesome/free-solid-svg-icons'
import { can } from '@core/libs/acl/utils'
import api from '@/app-modulo/comuns/certificado/shared/services/api'
import ultis from '@/@core/utils/file-utils'
import { canDownloadECPF, canDownloadECnpj, getUserData } from '@/auth/utils'

export default {
  name: 'EmpresaVisualizacao',
  components: {
    FontAwesomeIcon,
    certificadoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroAdicionalBase: () => import('@/shared/components/filtro-adicional-base/FiltroAdicionalBase.vue'),
    historicoCertificado: () => import('@/app-modulo/comuns/certificado/shared/components/historico-certificado/HistoricoCertificados.vue'),
    DePara: () => import('@/shared/components/de-para/DePara.vue'),
  },
  data() {
    return {
      faDownload,
      faHistory,
      colunasListagem: [
        {
          label: 'Certificado', field: 'empresaSocio', showActive: true, editable: true, type: 'personalizada',
        },
        { label: 'Tipo', field: 'tipo' },
        { label: 'Modelo', field: 'modelo' },
        { label: 'Vencimento', field: 'dataDeVencimento', type: 'personalizada' },
        { label: 'Observação', field: 'observacao', type: 'personalizada' },
      ],
      filtrosPrincipais: [
        { colunas: ['Tipo', 'Modelo', 'EmpresaSocio', 'dataDeVencimento', 'porProcuracao'], valor: null },
      ],
      dataVencimento: {
        dataInicio: null,
        dataFim: null,
      },
      filtros: {
        tipoFiltroCertificado: 1,
        modeloCertificado: null,
      },
      disabledDates: {},
      filtroCertificado: [
        { text: '', value: 0 },
        { text: 'Certificados ativos', value: 1 },
        { text: 'Certificados inativos', value: 2 },
        { text: 'Certificados vencidos', value: 3 },
        { text: 'Certificados à vencer nos próximos 30 dias', value: 4 },
        { text: 'Certificados com dispensa de alerta', value: 5 },
        { text: 'Certificados em processo', value: 6 },
      ],
      modeloCertificado: [
        { text: 'e-CPF', value: 1 },
        { text: 'e-CNPJ', value: 2 },
      ],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      carregado: false,
      userData: null,
    }
  },
  computed: {
    permissaoCreate: {
      get() {
        return can('create', this.$route.meta.resource)
      },
    },
    permissaoUpdate: {
      get() {
        return can('update', this.$route.meta.resource)
      },
    },
  },
  created() {
    this.userData = getUserData()
  },
  methods: {
    pesquisarFiltroCertificado() {
      this.$refs.certificadoList.montarGrid()
    },
    carregar(page, pageSize, filtro) {
      this.carregado = true
      const filtros = {
        filtroPricipal: filtro,
        filtrosAdicionais: this.filtros,
        dataVencimento: this.dataVencimento,
      }
      return api.getCertificados(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-certficado' })
    },
    exportarRelatorio() {
      const filtros = {
        filtroPricipal: {
          filtroBy: [
            { colunas: ['Tipo', 'Modelo', 'EmpresaSocio', 'dataDeVencimento', 'porProcuracao'], valor: null },
          ],
          ordemBy: [
            {
              coluna: '',
              tipo: '',
            },
          ],
        },
        filtrosAdicionais: this.filtros,
        dataVencimento: this.dataVencimento,
      }
      api.exportarRelatorio(filtros)
        .then(response => {
          if (response.data.url !== '') {
            document.getElementById('downloadRelatorio').href = response.data.url
            document.getElementById('downloadRelatorio').click()
          }
          this.deletarUpload(response.data.fileName)
        }).catch(err => {
          this.$erroResponse(err)
          throw err
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    deletarUpload(data) {
      setTimeout(() => {
        api.deleteUpload(data)
          .then(resolve => {
            this.$isLoading(false)
            this.$sucesso('Planilha gerada com sucesso')
            resolve()
          })
      }, 3000)
    },
    editar(value) {
      if (this.permissaoUpdate) {
        this.$router.push({ name: 'editar-certificado', params: { id: value.id } })
      }
    },
    editarObservacao(value) {
      if (!this.permissaoUpdate) {
        this.$router.push({ name: 'editar-observacao', params: { id: value.id } })
      }
    },
    remover(values) {
      if (values && values.length === 1) {
        return new Promise((resolve, reject) => {
          api.delete(values[0].id)
            .then(() => {
              resolve(false)
            })
            .catch(err => {
              reject(err)
            })
        })
      }

      const idList = values.map(map => map.id)
      return new Promise((resolve, reject) => {
        api.deleteAll({ identificadores: idList })
          .then(() => {
            resolve(false)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    validaVencido(dataDeVencimento) {
      const nowString = moment().format('DD/MM/YYYY')
      const now = moment(nowString, 'DD/MM/YYYY').toDate()
      const data = moment(dataDeVencimento, 'DD/MM/YYYY').toDate()
      return data < now
    },

    baixarCertificado(id) {
      api.GetCertificadoBy(id).then(payload => {
        this.AddHistoricos(id)
        const modelo = payload.data.modelo === 1 ? 'e-CNPJ' : 'e-CPF'
        if (payload.data.modelo === 1 && payload.data.tipo === 1 && canDownloadECnpj()) {
          ultis.downloadCertificado(payload.data.certificadoArquivo, payload.data.nome)
        } else if (payload.data.tipo === 1 && payload.data.modelo === 2 && canDownloadECPF()) {
          ultis.downloadCertificado(payload.data.certificadoArquivo, payload.data.nome)
        } else {
          this.$erro(`Você não tem permissão para realizar o download de certificado ${modelo}! Contate o administrador do sistema.`)
        }
      })
        .catch(err => {
          this.$erro(err)
        })
    },
    showHistoricos(id) {
      this.$refs.historicoCertificado.show(id)
    },
    AddHistoricos(id) {
      const tela = 'certificados'
      api.addHistorico(id, tela)
        .then(() => {
        })
        .catch(err => {
          this.$erro(err)
        })
    },
    LimpaFiltros() {
      this.dataVencimento = {
        dataInicio: null,
        dataFim: null,
      }
      this.filtros.modeloCertificado = null
      this.filtros.tipoFiltroCertificado = 1
      this.$refs.certificadoList.montarGrid()
    },
  },
}
</script>
